import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Проверяет доступность ресурса в Google Site Verification
 */
export const GSCHealthContentType = '' as const;
export type GSCHealthRequest = void;
export type GSCHealthResponses = LinkCommonErrorResponses & {
    /**
     * @description Сайт магазина не найден среди проверенных веб-ресурсов Google
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type GSCHealthResponseSuccess = undefined;
export type GSCHealthSearchParams = undefined;
export type GSCHealthPathParameters = undefined;
export const GSCHealthUrl = '/gsc/health' as const;
export const GSCHealthMethod = 'GET' as const;
export const getGSCHealthUrl = (_params?: GSCHealthPathParameters) => GSCHealthUrl;
